export const RELOAD_RESOURCE_MAX_RETRIES = 10;
export const RELOAD_RESOURCE_DELAY = 5;
export const SUBS_MIN_SIM_DEFAULT = 0.75;
export const SUBS_SIM_STEP = 0.2;
export const SUBS_MIN_DOWNGRADABLE = 0.45;
export const MAX_GRADE_QUIZZ = 5;
